export const LABEL_AND_FOLDER_REQ_TYPES = {
  LABEL: 'label',
  SUB_LABEL: 'subLabel',
} as const;

export type LabelAndFolderReqType =
  (typeof LABEL_AND_FOLDER_REQ_TYPES)[keyof typeof LABEL_AND_FOLDER_REQ_TYPES];
